var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Sibebar"},[_c('div',{staticClass:"Sibebar__close-link",on:{"click":function($event){return _vm.toggleSidebar()}}},[_c('IconBase',{attrs:{"iconName":"close"}},[_c('IconClose')],1)],1),_c('Navigation',{on:{"click":function($event){return _vm.toggleSidebar()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }